import { locationIdFormat } from "@redotech/redo-model/ids";
import { InventoryAdjustmentKind } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const exportAdjustmentHistory = {
  name: "exportAdjustmentHistory" as const,
  input: z.object({
    search: z.string().optional(),
    locationId: locationIdFormat.schema.optional(),
    kind: createEnum(InventoryAdjustmentKind).optional(),
    startDate: z.string().optional(), // ISO date string
    endDate: z.string().optional(), // ISO date string
    sendToEmail: z.string().optional(), // Email to send report to
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    reportData: z
      .array(
        z.object({
          date: z.string(),
          productTitle: z.string(),
          productSku: z.string().nullable(),
          locationName: z.string(),
          quantityDelta: z.number(),
          committedDelta: z.number(),
          notes: z.string().nullable(),
          activity: z.string(),
          referenceId: z.string().nullable(),
        }),
      )
      .optional(),
    emailSent: z.boolean().optional(),
  }),
};

export { InventoryAdjustmentKind } from "@redotech/redo-prisma-client/enums";
